import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { ListWrapper, ListSection, List, ListTitle } from '../list/index';
import { DishOptionSetList } from '../dish.option-set-list/index';
import { DishIngredientsList } from '../dish.ingredients-list/index';
class DishComboChoiceListClass extends React.Component {
    render() {
        const { choices, renderDetails, isBumpScreen = false } = this.props;
        return (React.createElement(ListWrapper, null, choices.map((choice, i) => {
            const selected = choice.selected;
            return (React.createElement(ListSection, { key: i },
                renderDetails.combo_choice_names && React.createElement(ListTitle, null,
                    React.createElement("span", { className: "underline" }, choice.name),
                    ": ",
                    selected.name),
                !renderDetails.combo_choice_names && React.createElement(ListTitle, null,
                    React.createElement("span", { className: "underline" }, selected.name)),
                React.createElement(List, { className: "p-l-2" },
                    selected.option_sets.length > 0 && (React.createElement("div", { className: "m-t-2" },
                        React.createElement(DishOptionSetList, { option_sets: selected.option_sets, renderDetails: renderDetails, isBumpScreen: isBumpScreen }))),
                    selected.ingredients.length > 0 && (React.createElement("div", { className: "m-t-2" },
                        React.createElement(DishIngredientsList, { ingredients: selected.ingredients }))))));
        })));
    }
}
export const DishComboChoiceList = withTranslation()(DishComboChoiceListClass);
//# sourceMappingURL=index.js.map